import React, { FC, PropsWithChildren } from 'react';
import { OrganisationalAccountActions } from './set-organisational-account';

export interface IOrganisationalAccountActionsProviderProps {

}

export const OrganisationalAccountActionsProvider: FC<PropsWithChildren<IOrganisationalAccountActionsProviderProps>> = ({ children }) => {
    return (
        <OrganisationalAccountActions>
                    {children}
        </OrganisationalAccountActions>
    );
};